export default __webpack_public_path__ + "static/pulzion23-c949fc8822d9daa52f8c4cdca33b57ae.png";